import { observer } from 'mobx-react-lite'
import { StyleSheet, View } from 'react-native'
import { Player } from '@ppwr/poker'
import { fontFamily } from '../../../theme'
import { PlayerRole } from '../PlayerRole'
import { DS } from '../../../design-system'
import { numberWithCommas } from '../../../utils/numberWithCommas'
import { DSColor, Palette } from '@ppwr/poker'
import { DSTypographyVariant, Typography } from '../../../design-system/Typography'
import { useStore } from '../../../models'
import MyFirstGameStepNames from '../../../models/game/first-game/MyFirstGameStepNames'
import { useResponsive } from '@/screens/new-design/hooks'
type PlayerChipsProps = {
  chips?: Player['chips']
  color?: DSColor
  right?: boolean
  role?: Player['role']
  chipsSize?: number
  variant?: DSTypographyVariant
  applyOpacity?: boolean
}

export const PlayerChips = observer(
  ({ chips, color, right, role, variant = 'Mini/Bold', chipsSize = 12, applyOpacity }: PlayerChipsProps) => {
    const {
      game: { isMyFirstGame, stageInternalName }
    } = useStore()

    const { verticalScale } = useResponsive()

    const renderRole = () => {
      if (isMyFirstGame && stageInternalName === MyFirstGameStepNames.roles) {
        return (
          <DS.Frame
            style={[
              {
                opacity: 1
              }
            ]}
          >
            <PlayerRole role={role as PlayerRole} size={'medium'} />
          </DS.Frame>
        )
      }

      return (
        <DS.Frame
          style={[
            {
              opacity: applyOpacity ? 0.4 : 1
            }
          ]}
        >
          <PlayerRole role={role as PlayerRole} />
        </DS.Frame>
      )
    }

    return (
      <View style={[styles.container, right ? styles.right : {}]}>
        {role && renderRole()}
        <DS.Frame style={{ opacity: applyOpacity ? 0.4 : 1 }}>
          <DS.Icon name="ChipOutline" color={color ? Palette[color] : Palette['Global/White']} size={chipsSize} />
        </DS.Frame>
        <DS.Text
          style={{
            opacity: applyOpacity ? 0.4 : 1,
            fontSize: verticalScale(Number(Typography[variant].fontSize)),
            lineHeight: verticalScale(Number(Typography[variant].lineHeight))
          }}
          variant={variant}
          color={color === 'Global/Black' ? 'Global/Black' : 'Brand/Light Grey'}
        >
          {numberWithCommas(chips ?? 0)}
        </DS.Text>
      </View>
    )
  }
)

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    textAlign: 'center',
    gap: 3,
    minHeight: 24
  },
  right: {
    flexDirection: 'row-reverse'
  },
  text: {
    fontFamily: fontFamily.GTAmericaExtendedMedium,
    textAlign: 'center',
    color: 'white',
    fontWeight: '700'
  }
})
